import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CancelTimeSlotMutation } from "../../../graphql/deliveryService/mutations/cancelTimeSlot";
import { SuccessOutputFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface CancelTimeSlotMutationMutationProps {
  inboundDeliveryId: string;
  dataAction?: (data: SuccessOutputFragment) => void;
  errorAction?: () => void;
}

const useCancelTimeSlotMutation = (
  props: CancelTimeSlotMutationMutationProps,
) => {
  const { t } = useTranslation();
  const { inboundDeliveryId, dataAction, errorAction } = props;

  const mutation = useMutation(CancelTimeSlotMutation, {
    update: (cache, result) => {
      const data = result.data?.cancelTimeSlot.successOutput;
      if (!data) return;

      const cacheId = cache.identify({
        __typename: "InboundDeliveryDetail",
        id: inboundDeliveryId,
      });
      cache.evict({ id: cacheId });
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const successFragment = data?.cancelTimeSlot.successOutput;

  useEffect(() => {
    if (!error) return;

    handleError(t("cancelTimeSlotError"), t(error.message), errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !successFragment) return;

    dataAction && dataAction(successFragment);
  }, [data]);

  return mutation;
};

export default useCancelTimeSlotMutation;
